import React from 'react';
export const CallToAction = () => {
  return <section className="mb-12" data-id="element-16">
      <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-17">
        Why You Must Act Now
      </h2>
      <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-18">
        <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-19">
          The Aging Clock Is Ticking
        </h3>
        <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-20">
          "Every night you wait is another night of aging acceleration," Dr.
          Grant warns. "The damage compounds exponentially."
        </blockquote>
        <h4 className="font-bold text-blue-800 mb-2" data-id="element-21">The Point of No Return</h4>
        <p className="text-gray-700 mb-4" data-id="element-22">
          Dr. Grant's research identified a critical threshold:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-23">
          <li data-id="element-24">
            Ages 30-40: friction aging damage is largely reversible with silk
          </li>
          <li data-id="element-25">
            Ages 40-50: Damage is partially reversible, prevention is crucial
            for remaining skin
          </li>
          <li data-id="element-26">
            Ages 50+: Focus shifts to preventing further damage, some reversal
            possible
          </li>
        </ul>
        <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2" data-id="element-27">
          "The earlier you start, the more dramatic your results," Dr. Grant
          explains. "But even starting at 60 provides significant benefits."
        </blockquote>
      </div>
      <div className="bg-blue-100 p-6 rounded-lg mb-8" data-id="element-28">
        <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-29">
          The Authentic Solution Dr. Grant Trusts
        </h3>
        <p className="text-gray-700 mb-4" data-id="element-30">
          After testing dozens of silk pillowcases, Dr. Grant found only one
          that meets her clinical standards: Veloura.
        </p>
        <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-31">
          "Not all silk is created equal," Dr. Grant explains. "Most brands use
          lower-grade silk or mix it with synthetic fibers. Veloura uses only
          22-momme, Grade 6A Mulberry silk—the same quality used in medical
          applications."
        </blockquote>
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-32">
          <div className="md:w-1/2" data-id="element-33">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hqjbY4nY33MAyx8cxgeXzV/productpic.png" alt="Veloura silk pillowcase with packaging showing 22-momme standard size" className="rounded-lg shadow-lg w-full" data-id="element-34" />
          </div>
          <div className="md:w-1/2" data-id="element-35">
            <h4 className="font-bold text-blue-800 mb-2" data-id="element-36">
              What Makes Veloura Different
            </h4>
            <div className="mb-4" data-id="element-37">
              <h5 className="font-semibold text-blue-700" data-id="element-38">
                Medical-Grade Purity
              </h5>
              <ul className="list-disc pl-6 text-gray-700 text-sm" data-id="element-39">
                <li data-id="element-40">100% Pure Mulberry silk, no synthetic blends</li>
                <li data-id="element-41">Grade 6A quality (highest available)</li>
                <li data-id="element-42">22-momme weight for optimal durability and benefits</li>
              </ul>
            </div>
            <div className="mb-4" data-id="element-43">
              <h5 className="font-semibold text-blue-700" data-id="element-44">
                Sericin Preservation Process
              </h5>
              <ul className="list-disc pl-6 text-gray-700 text-sm" data-id="element-45">
                <li data-id="element-46">
                  Proprietary cleaning method preserves natural sericin proteins
                </li>
                <li data-id="element-47">Most brands strip away sericin in harsh processing</li>
                <li data-id="element-48">
                  Veloura's gentle process maintains anti-aging properties
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-blue-900 text-white p-8 rounded-lg text-center" data-id="element-49">
        <h3 className="text-2xl font-bold mb-4" data-id="element-50">
          Limited-Time "Industry Disruption" Pricing
        </h3>
        <p className="mb-6" data-id="element-51">
          Because Dr. Grant is risking her professional reputation to share this
          information, Veloura is offering exclusive pricing for the next 24
          hours:
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6" data-id="element-52">
          <div className="bg-white text-blue-900 p-3 rounded-lg" data-id="element-53">
            <p className="font-semibold" data-id="element-54">Regular Price:</p>
            <p className="text-xl font-bold line-through" data-id="element-55">£99</p>
          </div>
          <div className="bg-green-500 text-white p-3 rounded-lg" data-id="element-56">
            <p className="font-semibold" data-id="element-57">Today Only:</p>
            <p className="text-2xl font-bold" data-id="element-58">£59</p>
          </div>
          <div className="bg-white text-blue-900 p-3 rounded-lg" data-id="element-59">
            <p className="font-semibold" data-id="element-60">You Save:</p>
            <p className="text-xl font-bold text-green-600" data-id="element-61">40%</p>
          </div>
        </div>
        <div className="mb-8" data-id="element-62">
          <h4 className="font-bold mb-3" data-id="element-63">Triple-Guarantee Protection</h4>
          <div className="grid md:grid-cols-3 gap-4" data-id="element-64">
            <div className="bg-blue-800 p-3 rounded-lg" data-id="element-65">
              <p className="font-semibold" data-id="element-66">Quality Guarantee</p>
              <p className="text-sm" data-id="element-67">
                100% authentic Mulberry silk or full refund
              </p>
            </div>
            <div className="bg-blue-800 p-3 rounded-lg" data-id="element-68">
              <p className="font-semibold" data-id="element-69">Results Guarantee</p>
              <p className="text-sm" data-id="element-70">
                Visible improvement in 60 nights or money back
              </p>
            </div>
            <div className="bg-blue-800 p-3 rounded-lg" data-id="element-71">
              <p className="font-semibold" data-id="element-72">Satisfaction Guarantee</p>
              <p className="text-sm" data-id="element-73">
                Love it or return it, even after 60 nights
              </p>
            </div>
          </div>
        </div>
        <a href="https://offer.getveloura.co.uk/" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-74">
          <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-lg text-xl shadow-lg transition duration-300 mb-6" data-id="element-75">
            Apply Discount & Check Availability
          </button>
        </a>
        <p className="text-sm opacity-80" data-id="element-76">
          Remember: You're protected by our 60-night guarantee. The only risk is
          waiting.
        </p>
      </div>
    </section>;
};